const BASE_URL = require('../config');
import React, { useState, useEffect } from 'react';

const API_URL = BASE_URL + '/api/plans';
const STAT_API_URL = BASE_URL + '/api/plan_statuses';

const PALETTE = [
  'bg-slate-200 text-slate-900', 'bg-red-200 text-red-900', 'bg-orange-200 text-orange-900',
  'bg-amber-200 text-amber-900', 'bg-emerald-200 text-emerald-900', 'bg-teal-200 text-teal-900',
  'bg-cyan-200 text-cyan-900', 'bg-blue-200 text-blue-900', 'bg-indigo-200 text-indigo-900', 'bg-purple-200 text-purple-900'
];

const toLocalIso = (d) => {
  const y = d.getFullYear(); const m = String(d.getMonth() + 1).padStart(2, '0'); const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

function RangeCalendar({ start, end, onSelect, onClose }) {
  const [view, setView] = useState(new Date());
  const nextM = () => setView(new Date(view.getFullYear(), view.getMonth() + 1, 1));
  const prevM = () => setView(new Date(view.getFullYear(), view.getMonth() - 1, 1));
  const daysInMonth = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
  const firstDay = new Date(view.getFullYear(), view.getMonth(), 1).getDay();
  const offset = (firstDay + 6) % 7;
  const days = [];
  for(let i=0; i<offset; i++) days.push(null);
  for(let i=1; i<=daysInMonth; i++) days.push(new Date(view.getFullYear(), view.getMonth(), i));

  const handleDay = (d) => {
    if(!d) return;
    const dStr = toLocalIso(d);
    if (!start || (start && end)) { onSelect(dStr, ''); } 
    else {
      const sTime = new Date(start).getTime(); const clickTime = d.getTime();
      if (clickTime < sTime) { onSelect(dStr, start); onClose(); } 
      else { onSelect(start, dStr); onClose(); }
    }
  };

  const isSelected = (d) => { if(!d) return false; const dt = toLocalIso(d); return dt === start || dt === end; };
  const isInRange = (d) => { if(!d || !start || !end) return false; const t = d.getTime(); const sT = new Date(start).getTime(); const eT = new Date(end).getTime(); return t > sT && t < eT; };
  const monthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

  return (
    <div className="absolute top-full left-0 mt-2 bg-white border border-slate-200 shadow-2xl rounded-2xl p-5 w-[320px] z-50 cursor-default" onClick={e => e.stopPropagation()}>
       <div className="flex justify-between items-center mb-4"><button type="button" onClick={prevM} className="w-8 h-8 rounded hover:bg-slate-100 font-bold text-slate-500 transition-colors">&lt;</button><span className="font-bold text-slate-800 text-sm uppercase tracking-wider">{monthNames[view.getMonth()]} {view.getFullYear()}</span><button type="button" onClick={nextM} className="w-8 h-8 rounded hover:bg-slate-100 font-bold text-slate-500 transition-colors">&gt;</button></div>
       <div className="grid grid-cols-7 gap-1 text-center mb-2">{['Пн','Вт','Ср','Чт','Пт','Сб','Вс'].map(w => <div key={w} className="text-[10px] font-bold text-slate-400">{w}</div>)}</div>
       <div className="grid grid-cols-7 gap-1 text-center">
         {days.map((d, i) => {
            if(!d) return <div key={i} className="w-9 h-9" />;
            const sel = isSelected(d); const inR = isInRange(d);
            return (<div key={i} onClick={() => handleDay(d)} className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm cursor-pointer transition-all ${sel ? 'bg-indigo-600 text-white font-bold shadow-md scale-105' : (inR ? 'bg-indigo-100 text-indigo-800' : 'text-slate-700 hover:bg-slate-100')}`}>{d.getDate()}</div>)
         })}
       </div>
       <div className="mt-5 border-t border-slate-100 pt-3 flex justify-between items-center">
         <button type="button" onClick={() => onSelect('','')} className="text-xs text-slate-400 hover:text-red-500 font-bold transition-colors">Сбросить</button>
         <button type="button" onClick={onClose} className="text-xs bg-slate-800 text-white px-3 py-1.5 rounded hover:bg-slate-900 font-bold transition-colors">Готово</button>
       </div>
    </div>
  );
}

function SearchableSelect({ options, value, onChange, placeholder }) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [debounced, setDebounced] = useState('');
  useEffect(() => {
    const t = setTimeout(() => setDebounced(search), 250);
    return () => clearTimeout(t);
  }, [search]);
  const filtered = options.filter(c => c.name.toLowerCase().includes(debounced.toLowerCase()));
  return (
    <div className="relative w-full min-w-[120px]">
      <div onClick={(e) => { e.stopPropagation(); setIsOpen(!isOpen); }} className="border border-indigo-400 p-1.5 rounded bg-white cursor-pointer flex justify-between items-center shadow-inner">
        <span className={value ? "text-slate-800 truncate text-xs text-left" : "text-slate-400 truncate text-xs text-left"}>{value || placeholder}</span><span className="text-slate-400 text-[10px] ml-1">▼</span>
      </div>
      {isOpen && (
        <div className="absolute z-50 min-w-[200px] w-full mt-1 bg-white border border-slate-200 rounded-lg shadow-xl max-h-60 overflow-y-auto left-0" onClick={e => e.stopPropagation()}>
          <div className="p-1.5 sticky top-0 bg-white border-b border-slate-100"><input type="text" placeholder="Поиск..." value={search} onChange={e => setSearch(e.target.value)} autoFocus className="w-full border border-slate-200 p-1.5 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 text-xs text-left" /></div>
          {filtered.map(c => {
             const bgClass = c.color ? c.color.split(' ')[0] : null;
             return (<div key={c.id} onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChange(c.name); setIsOpen(false); setSearch(''); }} className="p-2 hover:bg-indigo-50 cursor-pointer text-slate-700 border-b border-slate-50 last:border-0 flex items-center text-xs text-left">{bgClass && <div className={`w-2.5 h-2.5 rounded-full mr-1.5 shrink-0 ${bgClass}`}></div>}{c.name}</div>)
          })}
          {filtered.length === 0 && <div className="p-2 text-slate-400 text-xs text-center">Ничего не найдено</div>}
        </div>
      )}
    </div>
  );
}

function DictionaryModal({ title, isOpen, onClose, items, onAdd, onUpdate, onDelete }) {
  const [newName, setNewName] = useState(''); const [newColor, setNewColor] = useState(PALETTE[0]); const [editingId, setEditingId] = useState(null); const [editName, setEditName] = useState(''); const [editColor, setEditColor] = useState('');
  useEffect(() => { if (isOpen) { setNewColor(PALETTE[0]); setNewName(''); setEditingId(null); } }, [isOpen]);
  if (!isOpen) return null;
  const handleAdd = () => { if (newName.trim()) { onAdd(newName, newColor); setNewName(''); setNewColor(PALETTE[0]); } };
  const handleUpdate = (id) => { if (editName.trim()) { onUpdate(id, editName, editColor); setEditingId(null); setEditName(''); } };

  return (
    <div className="fixed inset-0 bg-slate-900/60 z-[100] flex items-center justify-center p-4 backdrop-blur-sm">
      <div className="bg-white rounded-xl w-full max-w-lg shadow-2xl overflow-hidden flex flex-col max-h-[80vh]">
        <div className="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50"><h2 className="text-lg font-bold text-slate-800 text-left">{title}</h2><button onClick={onClose} className="text-slate-400 hover:text-red-500 font-bold text-lg px-2">✕</button></div>
        <div className="p-4 overflow-y-auto flex-1">
          <div className="mb-4 p-3 bg-slate-50 border border-slate-100 rounded-lg">
            <div className="flex space-x-2"><input type="text" placeholder="Новое значение..." value={newName} onChange={(e) => setNewName(e.target.value)} className="flex-1 border border-slate-300 p-2 rounded focus:ring-1 focus:ring-indigo-500 outline-none text-sm text-left" /><button onClick={handleAdd} className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 rounded font-semibold shadow-sm transition-colors text-sm">Добавить</button></div>
            <div className="flex items-center mt-3"><span className="text-xs text-slate-500 uppercase font-bold mr-2 w-10 text-left">Цвет:</span><div className="flex flex-wrap gap-1.5">{PALETTE.map(c => { const isSelected = newColor === c; return (<div key={c} onClick={() => setNewColor(c)} className={`w-6 h-6 rounded-full cursor-pointer flex items-center justify-center transition-all ${c.split(' ')[0]} ${isSelected ? 'ring-2 ring-offset-1 ring-slate-400 scale-110' : 'opacity-70 hover:opacity-100'}`}>{isSelected && <span className={`font-bold text-[10px] ${c.split(' ')[1]}`}>✓</span>}</div>); })}</div></div>
          </div>
          <div className="space-y-2">
            {items.map(item => (
              <div key={item.id} className="p-3 bg-white border border-slate-200 rounded-lg hover:shadow-sm transition-shadow">
                {editingId === item.id ? (
                  <div className="flex flex-col space-y-3">
                    <div className="flex space-x-2"><input type="text" value={editName} onChange={(e) => setEditName(e.target.value)} autoFocus className="flex-1 border border-indigo-300 p-1.5 rounded outline-none focus:ring-1 focus:ring-indigo-500 text-sm text-left" /><button onClick={() => handleUpdate(item.id)} className="bg-emerald-500 hover:bg-emerald-600 text-white px-3 py-1.5 rounded text-xs font-bold">✓</button><button onClick={() => setEditingId(null)} className="bg-slate-200 hover:bg-slate-300 text-slate-700 px-3 py-1.5 rounded text-xs font-bold">✕</button></div>
                    <div className="flex items-center mt-3 pt-2 border-t border-slate-100"><span className="text-xs text-slate-500 uppercase font-bold mr-2 w-10 text-left">Цвет:</span><div className="flex flex-wrap gap-1.5">{PALETTE.map(c => { const isSelected = editColor === c; return (<div key={c} onClick={() => setEditColor(c)} className={`w-6 h-6 rounded-full cursor-pointer flex items-center justify-center transition-all ${c.split(' ')[0]} ${isSelected ? 'ring-2 ring-offset-1 ring-slate-400 scale-110' : 'opacity-70 hover:opacity-100'}`}>{isSelected && <span className={`font-bold text-[10px] ${c.split(' ')[1]}`}>✓</span>}</div>); })}</div></div>
                  </div>
                ) : (
                  <div className="flex justify-between items-center">
                    <div className="flex items-center"><div className={`w-3 h-3 rounded-full mr-2 ${(item.color || PALETTE[0]).split(' ')[0]}`}></div><span className="font-semibold text-slate-700 text-sm flex-1 text-left">{item.name}</span></div>
                    <div className="flex space-x-2"><button onClick={() => { setEditingId(item.id); setEditName(item.name); setEditColor(item.color || PALETTE[0]); }} className="text-indigo-500 hover:text-indigo-700 font-medium text-xs px-2">Изменить</button><button onClick={() => { if(window.confirm('Точно удалить?')) onDelete(item.id); }} className="text-red-400 hover:text-red-600 font-medium text-xs px-2">Удалить</button></div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const InlineActions = ({ onSave, onCancel }) => (
  <div className="flex space-x-1 ml-2">
    <button onClick={onSave} className="bg-emerald-500 text-white rounded hover:bg-emerald-600 flex items-center justify-center w-6 h-6 shadow-sm transition-transform hover:scale-105 shrink-0">✓</button>
    <button onClick={onCancel} className="bg-red-400 text-white rounded hover:bg-red-500 flex items-center justify-center w-6 h-6 shadow-sm transition-transform hover:scale-105 shrink-0">✕</button>
  </div>
);

export default function PlanningPage() {
  const [plans, setPlans] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [showForm, setShowForm] = useState(false);
  
  const [itemName, setItemName] = useState('');
  const [price, setPrice] = useState('');
  const [status, setStatus] = useState('');
  const [comment, setComment] = useState('');
  
  const [formCalStart, setFormCalStart] = useState('');
  const [formCalEnd, setFormCalEnd] = useState('');
  const [showFormCal, setShowFormCal] = useState(false);

  const [selectedIds, setSelectedIds] = useState([]);
  const [modalType, setModalType] = useState(null);
  const [editingCell, setEditingCell] = useState(null); 
  const [cellEditValue, setCellEditValue] = useState('');
  const [showCellCal, setShowCellCal] = useState(false);

  const fetchData = async () => {
    try {
      const [plansRes, statRes] = await Promise.all([ fetch(API_URL, { headers: { 'tg-id': window.localStorage.getItem('tg_user') || '' } }), fetch(STAT_API_URL, { headers: { 'tg-id': window.localStorage.getItem('tg_user') || '' } }) ]);
      if (plansRes.ok) setPlans(await plansRes.json());
      if (statRes.ok) setStatuses(await statRes.json());
    } catch (error) { console.error('Ошибка:', error); }
  };
  useEffect(() => { fetchData(); }, []);

  const addDictItem = async (url, name, color) => { await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify({ name, color }) }); fetchData(); };
  const updateDictItem = async (url, id, name, color) => { await fetch(`${url}/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify({ name, color }) }); fetchData(); };
  const deleteDictItem = async (url, id) => { await fetch(`${url}/${id}`, { method: 'DELETE', headers: { 'tg-id': window.localStorage.getItem('tg_user') || '' } }); fetchData(); };

  const handleAdd = async () => {
    if (!itemName || !price || !status) return alert("Заполните 'Необходимо купить', 'Цена' и 'Статус'");
    const planned_date = formCalStart && formCalEnd ? `${formCalStart} — ${formCalEnd}` : formCalStart;
    
    const payload = { item_name: itemName, price: parseFloat(price), status, planned_date, comment, completion_state: null };
    try { 
      const res = await fetch(API_URL, { method: 'POST', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify(payload) }); 
      if (res.ok) { setItemName(''); setPrice(''); setStatus(''); setComment(''); setFormCalStart(''); setFormCalEnd(''); setShowForm(false); fetchData(); } 
    } catch (error) { alert('Ошибка соединения'); }
  };

  const toggleSelect = (id) => { if (selectedIds.includes(id)) setSelectedIds(selectedIds.filter(i => i !== id)); else setSelectedIds([...selectedIds, id]); };
  const deleteSelected = async () => { if (!window.confirm(`Удалить ${selectedIds.length} позиций?`)) return; try { await fetch(BASE_URL + '/api/plans/batch', { method: 'DELETE', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify({ ids: selectedIds }) }); setSelectedIds([]); fetchData(); } catch (error) { alert('Ошибка при удалении'); } };

  // ФУНКЦИЯ ДЛЯ ГАЛОЧЕК И КРЕСТИКОВ
  const handleCompletionToggle = async (id, state) => {
    const plan = plans.find(p => p.id === id);
    if (!plan) return;
    const newState = plan.completion_state === state ? null : state; // Сбрасываем, если нажать на активную
    const payload = { ...plan, completion_state: newState };
    try {
      await fetch(`${API_URL}/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify(payload) });
      fetchData();
    } catch (error) { alert('Ошибка сохранения статуса'); }
  };

  const startCellEdit = (plan, field) => { 
    setEditingCell({ id: plan.id, field }); 
    setCellEditValue(plan[field] || ''); 
    if(field === 'planned_date') setShowCellCal(true);
  };
  const cancelCellEdit = (e) => { if(e) e.stopPropagation(); setEditingCell(null); setCellEditValue(''); setShowCellCal(false); };

  const saveCellEdit = async (e) => {
    if(e) e.stopPropagation();
    if (!editingCell) return;
    const { id, field } = editingCell;
    const plan = plans.find(p => p.id === id);
    if (!plan) return;

    const payload = { ...plan };
    if (field === 'price') payload.price = parseFloat(cellEditValue) || 0;
    else payload[field] = cellEditValue;

    try { await fetch(`${API_URL}/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify(payload) }); setEditingCell(null); setShowCellCal(false); fetchData(); } catch (error) { alert('Ошибка сохранения'); }
  };

  const handleDirectSave = async (val, field) => {
    if (!editingCell) return;
    const { id } = editingCell;
    const plan = plans.find(p => p.id === id);
    if (!plan) return;

    const payload = { ...plan };
    payload[field] = val;

    try { await fetch(`${API_URL}/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'tg-id': window.localStorage.getItem('tg_user') || '' }, body: JSON.stringify(payload) }); setEditingCell(null); fetchData(); } catch (error) { alert('Ошибка сохранения'); }
  };

  const renderCell = (colId, plan, isSelected) => {
    const isCellEditing = editingCell?.id === plan.id && editingCell?.field === colId;
    const isCompleted = plan.completion_state === 'done' || plan.completion_state === 'canceled';
    const textDecoration = isCompleted ? 'line-through opacity-50' : '';
    
    const cellClass = `px-4 py-3 cursor-pointer transition-all border-r border-slate-200 last:border-r-0 text-left ${textDecoration}`;
    const handleClick = () => { if (!isCellEditing && colId !== 'checkbox' && colId !== 'id' && colId !== 'completion_state') startCellEdit(plan, colId); };
    const statColorClass = statuses.find(s => s.name === plan.status)?.color || PALETTE[0];

    if (isCellEditing) {
      let inputElement;
      const isDropdown = colId === 'status';
      
      if (colId === 'status') inputElement = <SearchableSelect options={statuses} value={cellEditValue} onChange={(v) => { setCellEditValue(v); handleDirectSave(v, colId); }} placeholder="Выбрать..." />;
      else if (colId === 'planned_date') inputElement = (
        <div className="relative w-full">
          <input type="text" readOnly value={cellEditValue} onClick={(e) => { e.stopPropagation(); setShowCellCal(!showCellCal); }} className="w-full border border-indigo-400 p-1.5 rounded text-xs outline-none cursor-pointer bg-white" placeholder="Выберите дату..." />
          {showCellCal && <RangeCalendar start={cellEditValue.split(' — ')[0] || ''} end={cellEditValue.split(' — ')[1] || ''} onSelect={(s, e) => setCellEditValue(s && e ? `${s} — ${e}` : s)} onClose={() => setShowCellCal(false)} />}
        </div>
      );
      else if (colId === 'price') inputElement = <input type="number" value={cellEditValue} onChange={e => setCellEditValue(e.target.value)} autoFocus className="w-full border border-indigo-400 p-1.5 rounded text-xs outline-none shadow-inner text-left" />;
      else inputElement = <input type="text" value={cellEditValue} onChange={e => setCellEditValue(e.target.value)} autoFocus className="w-full border border-indigo-400 p-1.5 rounded text-xs outline-none shadow-inner text-left" />;

      return (
        <td key={colId} className="px-4 py-3 bg-indigo-50 border-r border-slate-200 last:border-r-0 overflow-visible">
          <div className="flex items-center w-full min-w-[150px]">
            {inputElement}
            {!isDropdown && <InlineActions onSave={saveCellEdit} onCancel={cancelCellEdit} />}
          </div>
        </td>
      );
    }

    switch(colId) {
      case 'checkbox': return <td key={colId} className="px-4 py-3 border-r border-slate-200 text-left"><input type="checkbox" checked={isSelected} onChange={() => toggleSelect(plan.id)} className="w-4 h-4 text-indigo-600 rounded cursor-pointer" /></td>;
      case 'id': return <td key={colId} className={`px-4 py-3 border-r border-slate-200 text-slate-400 font-mono text-left ${textDecoration}`}>#{plan.id}</td>;
      case 'item_name': return <td key={colId} onClick={handleClick} className={`${cellClass} font-bold text-slate-800 min-w-[200px] max-w-[350px] whitespace-normal break-words hover:text-indigo-600`} title="Нажмите для редактирования">{plan.item_name}</td>;
      case 'price': return <td key={colId} onClick={handleClick} className={`${cellClass} font-semibold text-emerald-600 whitespace-nowrap`} title="Нажмите для редактирования">{plan.price} ₽</td>;
      case 'status': return <td key={colId} onClick={handleClick} className={cellClass} title="Нажмите для редактирования"><span className={`px-2 py-0.5 rounded text-xs font-medium ${statColorClass}`}>{plan.status || '-'}</span></td>;
      case 'planned_date': return <td key={colId} onClick={handleClick} className={`${cellClass} text-indigo-600 font-bold whitespace-nowrap`} title="Нажмите для редактирования">{plan.planned_date ? `📅 ${plan.planned_date.replace(/(\d{4})-(\d{2})-(\d{2})/g, '$3.$2.$1')}` : '-'}</td>;
      case 'comment': return <td key={colId} onClick={handleClick} className={`${cellClass} text-slate-500 min-w-[200px] max-w-[350px] whitespace-normal break-words`} title="Нажмите для редактирования">{plan.comment || '-'}</td>;
      
      // КОЛОНКА ИТОГ (КНОПКИ)
      case 'completion_state': return (
        <td key={colId} className="px-4 py-3 text-center border-r border-slate-200 last:border-r-0" onClick={e => e.stopPropagation()}>
          <div className="flex justify-center space-x-2">
            <button onClick={() => handleCompletionToggle(plan.id, 'done')} title="Выполнено" className={`w-7 h-7 rounded-full flex items-center justify-center font-bold text-sm transition-all hover:scale-110 ${plan.completion_state === 'done' ? 'bg-emerald-500 text-white shadow-inner ring-2 ring-emerald-300 ring-offset-1' : 'bg-slate-100 text-slate-400 hover:bg-emerald-100 hover:text-emerald-600'}`}>✓</button>
            <button onClick={() => handleCompletionToggle(plan.id, 'canceled')} title="Отменено" className={`w-7 h-7 rounded-full flex items-center justify-center font-bold text-xs transition-all hover:scale-110 ${plan.completion_state === 'canceled' ? 'bg-red-500 text-white shadow-inner ring-2 ring-red-300 ring-offset-1' : 'bg-slate-100 text-slate-400 hover:bg-red-100 hover:text-red-600'}`}>✕</button>
          </div>
        </td>
      );
      default: return null;
    }
  };

  const cols = ['checkbox', 'id', 'item_name', 'price', 'status', 'planned_date', 'comment', 'completion_state'];
  
  // Считаем сумму только тех планов, которые НЕ отменены и НЕ выполнены
  const totalPlannedPrice = plans.filter(p => !p.completion_state).reduce((sum, p) => sum + (p.price || 0), 0);

  return (
    <div className="max-w-[1500px] mx-auto pb-48 relative mt-0 px-2 mt-0 mt-0">
      <div className="flex justify-between items-center mb-1 h-[32px]">
        <h1 className="text-[11px] font-bold text-slate-700">Планирование</h1>
        <div className="flex space-x-3 items-center">
          <div className="text-sm font-bold text-slate-500 bg-white border border-slate-200 px-4 py-2 rounded-lg shadow-sm">
            Активные планы: <span className="text-emerald-600 ml-1 text-lg">{new Intl.NumberFormat('ru-RU').format(totalPlannedPrice)} ₽</span>
          </div>
          {selectedIds.length > 0 && <button onClick={deleteSelected} className="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded font-semibold shadow-sm transition-colors text-sm">Удалить ({selectedIds.length})</button>}
          <button onClick={() => setShowForm(!showForm)} className="bg-indigo-600 hover:bg-indigo-700 text-white px-2 py-0.5 rounded font-semibold transition-colors text-[11px]">{showForm ? 'Скрыть' : '+ План'}</button>
        </div>
      </div>

      {showForm && (
        <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-200 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-6 gap-3 items-end">
            <div className="col-span-1 md:col-span-2">
              <label className="text-[10px] text-slate-500 font-bold mb-1 block uppercase">Необходимо купить *</label>
              <input type="text" value={itemName} onChange={(e) => setItemName(e.target.value)} className="w-full border border-slate-300 p-2 rounded focus:ring-1 focus:ring-indigo-500 text-sm" placeholder="Например, видеокарта RTX 5090" />
            </div>
            <div className="col-span-1">
              <label className="text-[10px] text-slate-500 font-bold mb-1 block uppercase">Цена (₽) *</label>
              <input type="number" value={price} onChange={(e) => setPrice(e.target.value)} className="w-full border border-slate-300 p-2 rounded text-sm focus:ring-1 focus:ring-indigo-500" placeholder="0" />
            </div>
            <div className="col-span-1">
              <label className="text-[10px] text-slate-500 font-bold mb-1 block uppercase">Статус *</label>
              <SearchableSelect options={statuses} value={status} onChange={setStatus} placeholder="Выбрать..." />
            </div>
            <div className="col-span-1 relative">
              <label className="text-[10px] text-slate-500 font-bold mb-1 block uppercase">Планируемая дата</label>
              <input type="text" readOnly value={formCalStart && formCalEnd ? `${formCalStart} — ${formCalEnd}` : formCalStart} onClick={() => setShowFormCal(!showFormCal)} className="w-full border border-slate-300 p-2 rounded text-sm outline-none cursor-pointer" placeholder="Период (опц.)" />
              {showFormCal && <RangeCalendar start={formCalStart} end={formCalEnd} onSelect={(s, e) => { setFormCalStart(s); setFormCalEnd(e); }} onClose={() => setShowFormCal(false)} />}
            </div>
            <div className="col-span-1 md:col-span-2">
              <label className="text-[10px] text-slate-500 font-bold mb-1 block uppercase">Комментарий</label>
              <input type="text" value={comment} onChange={(e) => setComment(e.target.value)} className="w-full border border-slate-300 p-2 rounded text-sm focus:ring-1 focus:ring-indigo-500" placeholder="Свободный текст" />
            </div>
            <div className="col-span-1">
              <button onClick={handleAdd} className="w-full bg-emerald-500 hover:bg-emerald-600 text-white p-2 rounded font-bold shadow-sm text-sm">Добавить</button>
            </div>
          </div>
        </div>
      )}

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-x-auto">
        <table className="min-w-full text-left whitespace-nowrap text-xs">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="px-4 py-3 w-10 border-r border-slate-200"></th>
              <th className="px-4 py-3 text-slate-500 font-bold uppercase text-left border-r border-slate-200">ID</th>
              <th className="px-4 py-3 text-slate-500 font-bold uppercase text-left border-r border-slate-200">Необходимо купить</th>
              <th className="px-4 py-3 text-slate-500 font-bold uppercase text-left border-r border-slate-200">Цена</th>
              <th className="px-4 py-3 text-slate-500 font-bold uppercase text-left border-r border-slate-200">
                <div className="flex items-center justify-between group">
                  <span>Статус</span>
                  <span onClick={() => setModalType('stat')} title="Настроить статусы планирования" className="text-[12px] opacity-30 cursor-pointer hover:opacity-100 hover:scale-125 transition-all px-1 hidden group-hover:block">⚙️</span>
                </div>
              </th>
              <th className="px-4 py-3 text-slate-500 font-bold uppercase text-left border-r border-slate-200">Планируемая дата</th>
              <th className="px-4 py-3 text-slate-500 font-bold uppercase text-left border-r border-slate-200">Комментарий</th>
              <th className="px-4 py-3 text-slate-500 font-bold uppercase text-center w-24">Итог</th>
            </tr>
          </thead>
          <tbody>
            {plans.length === 0 ? (
               <tr><td colSpan={8} className="px-6 py-12 text-center text-slate-500">Планы пусты. Добавьте будущие закупки.</td></tr>
            ) : plans.map((plan) => {
              // Динамический фон строки в зависимости от галочки/крестика
              const rowBg = plan.completion_state === 'done' ? 'bg-emerald-50' : 
                            plan.completion_state === 'canceled' ? 'bg-red-50' : 
                            (selectedIds.includes(plan.id) ? 'bg-indigo-50/50' : 'hover:bg-slate-50');

              return (
                <tr key={plan.id} className={`border-b border-slate-200 transition-colors ${rowBg}`}>
                  {cols.map(colId => renderCell(colId, plan, selectedIds.includes(plan.id)))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      <DictionaryModal title="Статусы планирования" isOpen={modalType === 'stat'} onClose={() => setModalType(null)} items={statuses} onAdd={(name, color) => addDictItem(STAT_API_URL, name, color)} onUpdate={(id, name, color) => updateDictItem(STAT_API_URL, id, name, color)} onDelete={(id) => deleteDictItem(STAT_API_URL, id)} />
    </div>
  );
}
